
const state = {
	maintenanceDialog: false,
};

const getters = {
	isMaintenanceDialog: (state) => state.maintenanceDialog,
};
const actions = {
	storeMaintenanceDialog({commit}, payload) {
		commit('setMaintenanceDialog', payload.val);
	}
};
const mutations = {
	setMaintenanceDialog(state, value) {
		state.maintenanceDialog = value;
	},
};

export default {
	state,
	getters,
	actions,
	mutations
}